import projection from '../generated/pwd216f1.json';
import { AcceptanceManifest } from '../types';
export const pwd216f1AcceptanceManifest = projection as AcceptanceManifest;
